import { TranslationDict } from './ja'

const dict: TranslationDict = {
  'Welcome to React': 'Welcome to React and react-i18next',
  error: {
    '404': 'Page not found',
  },
  pages: {
    user: {
      sectionTitle: {
        user: 'User Information',
        salon: 'Store Information',
        invoice: 'Invoice Information',
      },
      breadcrumb: {
        home: 'Home',
        userInfo: 'User Information',
      },
    },
    common: {
      home: 'Home',
      close: 'Close',
      cancel: 'Cancel',
      delete: 'Delete',
      edit: 'Edit',
      save: 'Save',
      confirm: 'Confirm',
      back: 'Back',
      next: 'Next',
      search: 'Search',
      loading: 'Loading...',
      error: 'Error',
      success: 'Success',
      warning: 'Warning',
      info: 'Information',
      backorders: 'Backorders',
      menu: {
        title: 'Menu',
        confirmOrder: 'Check order',
        orderImport: 'Order import',
      },
    },
    contact: {
      title: 'Contact',
      form: {
        title: 'Contact Form',
        notice:
          'For inquiries regarding order details, products, or invoices, please contact your sales representative.',
        emailNotice:
          'Please check your reception settings to receive emails from "{{email}}".',
        businessHours: 'Business Hours: Monday to Friday 9:00-18:00',
        holidays:
          'Closed: Weekends and holidays (Inquiries outside business hours will be responded to on the next business day or later)',
      },
    },
    error: {
      title: 'Error',
      messages: {
        401: 'Authentication failed.\nPlease log in again.',
        403: 'Unauthorized operation was performed.\nPlease log in again.',
        404: 'Page not found.',
        500: 'The requested page could not be displayed',
        default: 'An error occurred',
      },
      loginButton: 'Go to Login',
      orderHistoryDetailNotFound: {
        message: {
          line1: 'We apologize, but for order details,',
          line2: 'please check from TOP > Purchase Information*.',
        },
        note: {
          line1: '*If this item is not displayed,',
          line2:
            'please contact your sales representative if you wish to use the "Purchase Information" feature.',
        },
      },
    },
    favorite: {
      title: 'Favorite List',
      detail: {
        title: 'Favorite List Details',
        noItems: 'No {{itemTitle}} in {{favoriteTitle}}',
        newListButton: 'Create New List',
        myList: 'My List',
        sharedList: 'Shared List',
        sharedListNote: 'Shared lists cannot be reordered',
        sort: 'Sort',
        deleteConfirmation: 'Delete list',
        deleteWarning: 'This operation cannot be undone.',
        deleteButton: 'Delete',
      },
      validation: {
        required: 'This field is required',
        minQuantity: 'Below {{min}}',
        maxQuantity: 'Exceeds {{max}}',
        maxNote: 'Exceeds {{max}} characters',
      },
    },
    guide: {
      title: 'Guide',
      search: {
        title: 'Search Results',
        placeholder: 'Search keywords in {{guideTitle}}',
        backToTop: 'Back to {{guideTitle}} Top',
        noResults: 'No {{guideTitle}} found matching the criteria.',
      },
    },
    invoice: {
      title: 'Invoice',
      download: {
        title: 'Invoice Download',
        description: 'A password is required to download the following file.',
        filename: 'ClientCode_TotalAmount_Date.pdf',
        password: 'Password',
        downloadButton: 'Download',
        errors: {
          invalidPassword:
            'Invoice download failed\nPlease check your password and try again',
          notFound: 'Invoice file not found',
          systemError: 'System error occurred',
        },
      },
    },
    item: {
      title: 'Item',
      search: {
        title: 'Search',
      },
      detail: {
        title: 'Details',
        productInfo: 'Product Details',
      },
    },
    login: {
      title: 'Login',
      fields: {
        loginId: 'Login ID',
        password: 'Password',
      },
      buttons: {
        login: 'Login',
      },
      errors: {
        invalidCredentials: 'Invalid login ID or password',
        systemError: 'System error occurred',
      },
      messages: {
        logoutSuccess: 'Successfully logged out',
      },
    },
  },
  common: {
    yes: 'Yes',
    no: 'No',
    or: 'or',
    japanese: 'Japanese',
    english: 'English',
    action: {
      close: 'Close',
      update: 'Update',
      save: 'Save',
      delete: 'Delete',
    },
    symbol: {
      separator: '/',
    },
    detail: 'Details',
    required: 'Required',
    receive: 'Receive',
    doNotReceive: 'Do Not Receive',
    menu: {
      title: 'Menu',
    },
    pagination: {
      fromTo: 'All {{total}} items from {{from}} to {{to}}',
    },
    filter: {
      title: 'Filter',
      execute: 'Filter',
      reset: 'Reset Filter Conditions',
      search: 'Search',
    },
    placeholder: {
      select: 'Select...',
      selectAll: 'All',
      unselectAll: 'Unselect All',
      itemSelected: '{{count}} selected',
      all: 'All',
      fromDate: 'From',
      toDate: 'To',
    },
    label: {
      itemUnit: 'items',
      searchUnit: 'items',
      yen: 'yen',
    },
    error: {
      required: 'Required',
      invalid: 'Invalid',
      incorrect: 'Incorrect',
      noItem: 'No items',
      null: 'Does not exist',
      status: 'Invalid status',
      over: 'Exceeds the limit',
      sameAsNow: 'Already in use',
      statusCode: {
        '504':
          'The process took too long and could not be completed successfully.\nPlease try again after a while.\nIf the problem persists, please contact us through the contact form.',
        '400': {
          address: {
            searchByZipCode: 'Invalid postal code',
          },
          favorite: {
            copy: {
              expired: 'Product has been discontinued',
              unavailable: 'Product is out of sales period',
              forbidden: 'Product cannot be handled',
            },
          },
          cart: {
            delivaryDate: {
              invalid: 'Date does not exist',
              incorrent:
                'Please select a date on or after the earliest delivery date',
            },
            order: {
              noItem: 'No items have been added to the cart',
              null: 'Cart does not exist',
            },
          },
          order: {
            deliveryDate: {
              over: 'The deadline for the specified delivery date has passed and cannot be changed',
            },
          },
          user: {
            changeEmail: {
              sameAsNow: 'Cannot change to the same email address',
            },
          },
        },
      },
      field: {
        itemCode: 'Item Code',
        groupId: 'Group ID',
        salonPriceLower: 'Salon Price Lower Limit',
        salonPriceUpper: 'Salon Price Upper Limit',
        retailPriceLower: 'Retail Price Lower Limit',
        retailPriceUpper: 'Retail Price Upper Limit',
        brandCodes: 'Brand',
        categoryIds: 'Category',
        salesStartFrom: 'Sales Start From',
        salesStartTo: 'Sales Start To',
        keywords: 'Search Keywords',
        lineupCode: 'Lineup Code',
        // Order related
        orderNo: 'Order Number',
        deliveryDateFrom: 'Delivery Start Date',
        deliveryDateTo: 'Delivery End Date',
        shipmentStatus: 'Shipment Status',
        approvalStatus: 'Approval Status',
        salesOrderNo: 'Sales Order Number',
        // Favorite related
        setNo: 'Favorite List Number',
        // Cart related
        address1: 'Address 1',
        address2: 'Address 2',
        deliveryDate: 'Delivery Date',
        zipCode: 'Postal Code',
        tel: 'Phone Number',
        deliveryName: 'Delivery Name',
        desiredDeliveryDate: 'Desired Delivery Date',
        // Order import related
        systemType: 'System Type',
        orderDateFrom: 'Import Date (Start)',
        fileContent: 'File Content',
        fileName: 'File Name',
        fileId: 'File ID',
        // Invoice related
        invoiceId: 'Invoice ID',
        // Common
        storeCode: 'Store Code',
        page: 'Page Number',
        pageSize: 'Display Count',
      },
    },
  },
  backorders: {
    title: 'Backorders',
    noItems: 'No unallocated items',
    orderDate: 'Order Date',
    orderNo: 'Order No',
    itemName: 'Item Name',
    itemCode: 'Item Code',
    storeName: 'Store Name',
    orderedAt: 'Order Date',
    buyerName: 'Buyer Name',
    orderedQuantity: 'Ordered Qty',
    allocatedQuantity: 'Allocated Qty',
    unallocatedQuantity: 'Unallocated Qty',
    detail: 'Detail',
    status: {
      all: 'All Unallocated',
      partial: 'Partially Unallocated',
    },
  },
  login: {
    title: 'Login',
    employeeTitle: 'Employee Login',
    employeeLoginLink: 'Employee Login',
  },
  top: {
    menu: {
      orderHistory: 'Order History',
      favorite: 'Favorite',
      search: 'Search',
      orderImport: 'Order Import',
      ecOrderImport: 'EC Order Import',
      import: 'Import Information',
      invoice: 'Invoice',
      logout: 'Logout',
      priceChangeHistory: 'Price Change History',
      backorders: 'Backorders',
      subtitle: {
        invoice: 'Check invoice',
        other: 'Other',
      },
    },
    warning: {
      orderHistory: {
        approve: 'Approve is not completed',
      },
    },
  },
  components: {
    dnd: {
      dropCsv: 'Drop CSV file here',
      selectFile: 'Select File',
    },
  },
  user: {
    info: {
      userId: 'User ID',
      email: 'Email Address',
      password: 'Password',
      title: 'Customer Information',
      change: 'Change',
      notSet: 'Not Set',
      language: 'Language',
    },
    language: {
      title: 'Language Settings',
      changeTitle: 'Change Language Settings',
      changeSuccess: 'Language settings have been changed.',
      close: 'Close',
      message: {
        confirm: 'Change the language you are currently using?',
      },
    },
    email: {
      pendingVerification: 'Pending Verification',
      receiveSettings: {
        title: 'Email Notification Settings',
        changeTitle: 'Change Email Notification Settings',
        changeMessage:
          'Would you like to change your email notification settings?',
        receiveOrderCompletionEmail:
          'Would you like to receive order completion emails?',
        orderCompletionEmail: 'Order Completion Email',
        invoiceEmail: 'Invoice Notification Email',
        receive: 'Receive',
        receiveOption: 'Receive',
        doNotReceiveOption: 'Do Not Receive',
        changeSuccess: 'Email notification settings have been changed.',
      },
    },
    invoice: {
      viewPermission: 'Viewing Permission',
      email: {
        notificationEmail: 'Invoice Notification Email: ',
        receive: 'Receive',
        doNotReceive: 'Do Not Receive',
        receiveQuestion:
          'Would you like to receive invoice notification emails?',
        receiveOption: 'Receive',
        doNotReceiveOption: 'Do Not Receive',
      },
    },
    store: {
      storeCode: 'Store Code',
      storeName: 'Store Name',
      shippingAddress: 'Shipping Address',
      phoneNumber: 'Phone Number',
      honorific: 'sama',
    },
  },
  maintenance: {
    message: 'System is currently under maintenance',
    altairLogo: 'Altair Logo',
  },
  order: {
    title: 'Order',
    addSalesType: 'Add Sales Type',
    salesType: 'Sales Type',
    completed: {
      message: ' Order has been completed',
      orderNumber: 'Order Number',
      emailMessage: {
        line1: ' Order details have been sent to you by email.',
        line2:
          'If you do not receive the email, please check your spam folder.',
        line3: 'If you have any questions, please feel free to contact us.',
      },
      employee: {
        success: 'Employee proxy order has been completed',
        successWithWarnings: 'Order was created but some items are unallocated',
        failed: 'Employee proxy order could not be registered',
        noResult: 'Employee proxy order result cannot be displayed',
        ecOrderNo: 'EC Order No.',
        items: 'Item Results',
        itemCode: 'Item Code',
        itemName: 'Item Name',
        quantity: 'Quantity',
        status: 'Status',
        message: 'Message',
        unallocatedItems: 'Unallocated Items',
        orderedQuantity: 'Ordered Quantity',
        allocatedQuantity: 'Ordered',
        unallocatedQuantity: 'Shortage',
      },
    },
    action: {
      doAction: '',
      of: ' of ',
      to: ' ',
      close: 'Close',
      approve: 'Approve',
      revokeApprove: 'Revoke Approval',
      cancel: 'Cancel',
      delete: 'Delete',
      edit: 'Edit',
      save: 'Save',
      csvDownload: 'CSV Download',
      editContent: 'Edit Order Content',
      returnToTop: 'Return to Top',
      result: {
        approved: 'has been approved',
        notExists: 'Order does not exist',
        noApprovalAuthority: 'No approval authority',
        deliveryDateChangeRequired: 'Delivery date change required',
        alreadyApproved: 'Already approved',
        alreadyShipped: 'Already shipped',
        unavailableItems: 'Unavailable items exist',
        approvalRevoked: 'Approval has been revoked',
        alreadyRevoked: 'Approval already revoked',
        cancelled: 'has been cancelled',
        noCancelAuthority: 'No cancel authority',
        approvedCannotCancel: 'Cannot cancel an approved order',
        orderNumber: 'Order Number ',
        is: ' ',
      },
      message: {
        approve: 'Order has been approved',
        bulkApprove: 'Orders have been bulk approved',
        revokeApprove: 'Order approval has been revoked',
        bulkRevokeApprove: 'Order approvals have been bulk revoked',
        cancel: 'Order has been cancelled',
        bulkCancel: 'Orders have been bulk cancelled',
        returnToCart: 'Order has been returned to cart',
        updateDeliveryDate: 'Desired delivery date has been updated',
        updateShippingInfo: 'Delivery information has been updated',
        failedUpdateDeliveryDate: 'Failed to update desired delivery date',
        failedUpdateShippingInfo: 'Failed to update delivery information',
        failedUpdateItem:
          'Failed to update item for order number {{orderNumber}}',
        failedBulkCancel:
          'Failed to cancel orders with order numbers {{orderNumbers}}',
      },
    },
    field: {
      orderNumber: 'Order Number',
    },
    label: {
      visibleOrder: 'Visible Order Information',
      totalItemCount: 'Total Item Count',
      storeCount: 'Store Count',
      totalSalonPrice: 'Total Salon Price',
    },
    modal: {
      editTitle: 'Edit Order Content',
      editContent: 'Edit Order Content',
      deleteTitle: 'Delete Item',
      deleteContent: 'This operation cannot be undone.',
      warning: {
        overwriteCart: 'Overwrite cart.',
        cannotUndo: 'This operation cannot be undone.',
        removeFromOrderHistory: 'Order will be removed from order history',
      },
      itemDetail: {
        title: 'Item Details',
      },
    },
    payment: {
      title: 'Payment Information',
      subtotal: 'Subtotal',
      tax: 'Tax',
      total: 'Total',
      order: {
        current: 'Current Order',
        unshipped: 'Other orders scheduled for same-day delivery',
        totalPrice: 'Total Amount',
        untilFreeShippingPrice: 'Until Free Shipping',
      },
      shipping: {
        shippingFee: 'Shipping Fee',
      },
    },
    status: {
      unshipped: 'Unshipped',
      approved: 'Approved',
      unapproved: 'Unapproved',
      error: 'Error',
    },
    shipping: {
      title: 'Shipping Address',
      regularDeliveryDate: 'Regular Delivery Date',
      change: 'Change',
      titleShort: 'Shipping',
      shippingDate: 'Shipping Date',
      shippingInfo: 'Shipping Information',
      desiredDeliveryDate: 'Desired Delivery Date',
      zipCode: 'Zip Code',
      tel: 'Tel',
      deliveryName: 'Delivery Name',
      info: 'Shipping Information',
      status: 'Shipping',
    },
    item: {
      title: 'Item',
      purchasePrice: 'Purchase Price',
      salonPrice: 'Salon Price',
      subtotal: 'Subtotal',
      quantity: 'Quantity',
      selectMultiple: 'Select Multiple Items',
      completeSelection: 'Complete Selection',
      closeAll: 'Close All',
      openAll: 'Open All',
      backorder: 'Backorder',
      backorderNote: '※Delivery may take up to one week',
      memo: 'Memo',
      addSalesType: 'Add Sales Type',
      selectPlaceholder: 'Please select',
      salesType: 'Type',
      currentOrder: 'Current Order',
    },
    message: {
      confirmDelete: 'Do you want to delete this item from all orders?',
    },
    history: {
      title: 'Order',
      detail: {
        title: 'Order Details',
      },
      label: {
        approval: {
          status: 'Approval',
        },
        displayCount: 'Count',
        currency: 'yen',
        units: 'items',
      },
      filter: {
        title: 'Filter',
        button: 'Filter',
        reset: 'Reset Filter Conditions',
        noSpecification: 'Not Specified',
        selectedStores: 'stores selected',
        allStores: 'All',
      },
      card: {
        desiredDeliveryDate: 'Desired Delivery Date',
        salesOrderNo: 'Sales Order No.',
        total: 'Total',
        shippingFee: 'Shipping Fee',
        storeName: 'Store',
        trackingNo: 'Tracking No.',
        freeShippingMessage: 'Free shipping after',
        freeShipping: 'Free',
        shippingCompanyName: 'Shipping Company',
        errorMessage: {
          unapproved: 'Unapproved orders exist',
          deliveryDateChange: 'Orders requiring delivery date change exist',
          cancelledOutOfStock:
            'Some items are out of stock, so shipment for the affected items has been stopped. Please reorder.',
          partialShippingPreparation:
            'Some items are out of stock, so shipment for the affected items has been stopped. Please reorder.',
          partialShipped:
            'Some items are out of stock, so shipment for the affected items has been stopped. Please reorder.',
        },
        none: 'Not Set',
      },
      status: {
        all: 'All',
        preparation: 'In Preparation',
        shipped: 'Shipped',
        approved: 'Approved',
        unapproved: 'Unapproved',
        unshipped: 'Unshipped',
        shippingPreparation: 'Shipping Preparation',
        cancelledOutOfStock: 'Cancelled Out of Stock',
        error: 'Error',
        partialShippingPreparation: 'Partial Shipping Preparation',
        partialShipped: 'Partial Shipped',
      },
      action: {
        bulkAction: {
          approve: 'Approve',
          revokeApproval: 'Revoke Approval',
          cancelOrder: 'Cancel Order',
          cancelAllOrder: 'Cancel All Orders',
          cancelUnshippedOrder: 'Cancel Unshipped Orders',
          cancelAll: 'Cancel All',
        },
        warning: {
          cancelMessage: 'You are about to cancel this order.',
          cancelOrderMessage: 'You are about to cancel this order.',
          cancelAllOrderMessage: 'You are about to cancel all orders.',
          cannotUndo: 'This action cannot be undone.',
        },
        approve: 'Approve',
        revokeApproval: 'Revoke Approval',
        cancel: 'Cancel',
        bulkApprove: 'Bulk Approve',
        bulkRevokeApproval: 'Bulk Revoke Approval',
        bulkCancel: 'Bulk Cancel',
      },
      backorder: {
        title: 'Backorder',
        note: '※Please allow some time for delivery',
      },
      emptyState: {
        alt: 'No orders image',
        noOrders: 'No orders found',
        shopNow: 'Shop Now',
      },
      titleShort: 'Order',
      fields: {
        deliveryDate: 'Delivery Date',
        orderNo: 'Order No.',
        salesOrderNo: 'Sales Order No.',
        storeCodes: 'Store Codes',
        shipmentStatus: 'Shipment Status',
        approvalStatus: 'Approval Status',
        salesTypeName: 'Sales Type',
        quantity: 'Quantity',
        price: 'Price',
        note: 'Note',
        summaryPrice: 'Summary Price',
      },
      search: {
        message: {
          noOrders: 'No orders found',
          action: {
            research: 'Please change the conditions and search again',
          },
        },
      },
    },
    import: {
      title: 'Order Import',
      result: {
        title: 'Order Import Results',
        type: 'Import Type',
        summary: {
          total: 'Total',
          success: 'Success Count',
          failure: 'Failure Count',
        },
        count: '{{count}} items',
        tableHeader: {
          orderNumber: 'Order Number',
          rowNumber: 'Row Number',
          result: 'Import Result',
          errorCode: 'Error Code',
          detail: 'Details',
        },
        status: {
          success: 'Success',
          error: 'Error',
        },
        filter: {
          all: 'All',
          success: 'Success Only',
          error: 'Errors Only',
        },
        close: 'Close',
      },
      search: {
        label: {
          systemType: 'Type',
          orderDateFromTo: 'Import Date',
        },
        placeholder: {
          systemType: 'Please select',
          orderDateFromTo: 'Please select',
        },
        button: 'Filter',
        message: {
          failedToFetch: 'Failed to fetch details',
          failedToDownload: 'Failed to download',
        },
      },
      table: {
        header: {
          result: 'Import Result',
          date: 'Import Date',
          type: 'Type',
          fileName: 'File Name',
          originalFile: 'Original File',
          executionResult: 'Execution Result',
          resultCount: 'Import Count',
        },
        status: {
          error: 'With Errors',
          failure: 'Failed',
          success: 'Success',
        },
        resultCount: {
          total: 'Total',
          separator: '/',
        },
        action: {
          download: 'Download',
          viewDetail: 'View Details',
        },
        noData: 'No data matching the criteria.',
      },
    },
  },
  announcement: {
    title: 'Announcements',
    viewDetails: 'View Details',
    close: 'Close',
    noReadData: 'There are no confirmed notifications.',
    noUnReadData: 'There are no unread notifications.',
    tags: {
      all: 'All',
      important: 'Important',
      newFeature: 'New Features',
      productInfo: 'Product Info',
      other: 'Other',
    },
    selectAll: 'Select all',
    markAllRead: 'Mark as read',
  },
  productHistory: {
    searchForm: {
      changeDate: 'Date range',
      productCode: 'Product Code',
      startDate: 'Start Date',
      endDate: 'End Date',
      button: 'Search',
      dateRangeError:
        'Please enter a start date that is on or before the end date.',
      productCodeChange: {
        label: 'Product Code Change',
        yes: 'Yes',
        no: 'No',
      },
    },
    table: {
      noData: 'No data available.',
      header: {
        productCode: 'Product Code',
        productName: 'Product Name',
        oldProductCode: 'Old Product Code',
        oldProductName: 'Old Product Name',
        newProductCode: 'New Product Code',
        newProductName: 'New Product Name',
        makerCode: 'Maker Code',
        makerName: 'Maker Name',
        oldRetailPrice: 'Old List Price',
        oldBsPrice: 'Old BS Price',
        newRetailPrice: 'List Price',
        newBsPrice: 'BS Price',
        effectiveDate: 'Price Change Date',
        sourceUpdatedAt: 'Data Updated Date',
      },
    },
  },
  auth: {
    validation: {
      required: 'This field is required',
      requiredInput: 'This field is required',
      minLength: 'Minimum length is {length} characters',
      maxLength: 'Maximum length is {length} characters',
      invalidEmail: 'Invalid email address',
      passwordMismatch: 'New passwords do not match',
    },
    password: {
      title: 'Change Password',
      currentPassword: 'Current Password',
      newPassword: 'New Password',
      newPasswordConfirm: 'New Password (Re-enter)',
      submit: 'Update',
      close: 'Close',
      updated: 'Password has been updated',
    },
    email: {
      title: 'Change Email',
      newEmail: 'Email',
      submit: 'Update',
      close: 'Close',
      complete: {
        message: 'We have sent an email to the saved address.',
        instruction:
          'Please open the URL in the email to complete the verification.',
      },
    },
    invoiceEmail: {
      title: 'Change Email',
      newEmail: 'Email',
      submit: 'Update',
      close: 'Close',
      complete: {
        message: 'We have sent an email to the saved address.',
        instruction:
          'Please open the URL in the email to complete the verification.',
      },
    },
    login: {
      title: 'Login',
      email: 'Email',
      password: 'Password',
      submit: 'Login',
      storeCode: 'Store Code',
      saveStoreCode: 'Use the same store code for next login',
      button: 'Login',
      userId: 'User ID',
    },
    employeeLogin: {
      forgotPassword: {
        prefix:
          'If you cannot log in or have forgotten your password, please contact us ',
        linkText: 'here',
        suffix: '.',
      },
    },
    changeEmail: {
      authenticating: 'Authenticating...',
      authFailed: 'Authentication failed.',
      authComplete: 'Email address authentication completed.',
      invalidToken:
        'The URL in the authentication email is incorrect or has expired.',
      returnToTop: 'Return to top',
    },
    modal: {
      categorySelection: 'Category Selection',
    },
  },
  brand: {
    group: {
      title: 'Brand Group',
    },
    item: {
      title: 'Brand',
    },
  },
  cart: {
    item: {
      title: 'Cart',
      count: 'Items in cart',
      empty: 'Your cart is empty',
      add: 'Add to cart',
      add_description: 'Add selected items to {{cart}}.',
      remove: 'Remove from cart',
      quantity: 'Quantity',
      price: 'Price',
      total: 'Total',
      noItems: 'No items in {{title}}',
      action: {
        remove: 'Empty cart',
        close: 'Close',
        empty: 'Empty',
        message: {
          clear: 'Cart has been cleared',
          remove: 'Item has been removed from cart',
        },
      },
      message: {
        remove: 'Are you sure you want to empty your cart?',
        notUndo: 'This action cannot be undone.',
        unavailableItems:
          'Some items are unavailable for purchase. Please remove them using the "Delete" button before proceeding to checkout.',
      },
    },
    shipping: {
      title: 'Delivery Information',
      address: 'Delivery Address',
      addressInfo: 'Delivery Address Information',
      name: 'Name',
      postalCode: 'Postal Code',
      phone: 'Phone Number',
      edit: 'Edit',
      add: 'Add',
      close: 'Close',
      submit: 'Save',
      searchByPostalCode: 'Search address by postal code',
      defaultAddress: 'Use default {{title}}',
      validation: {
        required: 'This field is required',
        maxLength: 'Maximum {length} characters allowed',
        invalidPostalCode: 'Invalid postal code',
        emojiNotAllowed: 'Emojis are not allowed (detected character: {char})',
        fullWidthRequired:
          'Please enter in full-width characters (detected character: {char})',
        invalidCharacters: 'Invalid characters detected',
      },
      message: {
        update: 'Delivery information has been updated',
        overDesiredDeliveryDate:
          'Available delivery dates have been updated. Reloading cart',
      },
    },
    payment: {
      title: 'Payment',
      subtotal: 'Subtotal',
      tax: 'Tax',
      total: 'Total',
      proceed: 'Proceed to Checkout',
      currency: 'yen',
      salonPrice: 'Salon Price',
      purchasePrice: 'Purchase Price',
      untilFreeShipping: 'Until Free Shipping',
      note: '※Includes other orders for same-day delivery',
      error: 'Error',
      confirmOrder: {
        title: 'Confirm Order',
        proceed: 'Proceed',
        cancel: 'Cancel',
        message1: 'I will place a proxy order for the following customer.',
        message2: 'Is that all right?',
        salonName: 'Salon',
      },
    },
    date: {
      title: 'Desired Delivery Date',
      select: 'Select delivery date',
      regular: 'Regular delivery date',
      change: 'Change',
      regularLabel: 'Regular delivery date: {{date}}',
      error: {
        required: 'Please select a delivery date',
        invalid: 'Invalid delivery date',
        unavailable: 'Selected date is not available for delivery',
        updated:
          'Available delivery dates have been updated. Please reselect your desired delivery date.',
      },
      message: {
        update: 'Desired delivery date has been updated',
      },
    },
    placeholder: {
      noMax: 'No maximum',
      noMin: 'No minimum',
    },
  },
  item: {
    title: 'Items',
    search: {
      title: 'Item Search',
      placeholder: {
        common: 'Search by item name, JAN code, or catalog number',
      },
      action: {
        bulkSelect: 'Select items',
        bulkSelectComplete: 'Select complete',
      },
      message: {
        changeConditions: 'Please change the conditions and search again',
      },
      error: {
        noResults: 'No search results',
      },
    },
    order: {
      detail: 'Detail',
      edit: 'Edit',
      delete: 'Delete',
      quantity: 'Quantity',
      price: 'Price',
      total: 'Total',
      close: 'Close',
      save: 'Save',
      memo: 'Memo',
      addSalesType: 'Add sales type',
      units: 'items',
      currency: 'yen',
      salonPrice: 'Salon price',
      purchasePrice: 'Purchase price',
      purchasePriceTotal: 'Purchase price total',
      averagePurchasePrice: 'Average purchase price',
      salesType: 'Sales type',
    },
    status: {
      available: 'Available',
      unavailable: 'Unavailable',
      expired: 'Order period expired',
      forbidden: 'Please contact your sales representative',
      noItemCode: 'Item code does not exist',
      outOfStock: 'Out of stock',
      discontinued: 'Discontinued',
    },
    card: {
      detail: 'Detail',
      color: {
        all: 'All colors',
      },
      status: {
        unavailable: 'Temporarily unavailable (please contact sales)',
        expired: 'Order period expired',
        forbidden: 'Please contact your sales representative',
        noItemCode: 'Item code does not exist',
        outOfStock: 'Out of stock',
        discontinued: 'Discontinued',
      },
    },
    favorite: {
      add: 'Add to favorites',
      remove: 'Remove from favorites',
      modal: {
        title: 'Add to favorites',
        submit: 'Add',
        cancel: 'Cancel',
        createNew: 'Create new list',
        filter: 'Filter',
      },
    },
    cart: {
      add: 'Add to cart',
      edit: 'Edit order',
      close: 'Close',
      remove: 'Remove from cart',
      title: 'Cart',
      addSuccess: ' added',
      addToCart: ' add to',
    },
    unit: 'pcs',
    detail: {
      view: 'View details',
      title: 'Item Details',
      allColors: 'All colors',
      sort: 'Sort',
      detailedSearch: 'Detailed search',
      searchCondition: 'Search conditions',
      searchResults: 'Search results:',
      search: 'Search',
      keyword: 'Keyword',
      searchButton: 'Search',
      purchasePrice: 'Purchase price',
      subtotal: 'Subtotal',
      itemName: 'Item name',
      brandName: 'Brand name',
      salonPrice: 'Salon price',
      retailPrice: 'Retail price',
      manufacturer: 'Manufacturer',
      volume: 'Volume',
      janCode: 'JAN Code',
      itemCode: 'Item Code',
      latestOrderDate: 'Latest order date',
      salesStartDate: 'Sales start date',
      order: 'Order',
      orderLimitExceeded: 'Stock quantity is limited to {{count}} pieces',
      loading: 'Loading...',
      loadingError: 'Loading error occurred',
      noResults: 'No search results',
      productImage: 'Product image',
      lastOrderDate: 'Previous delivery date',
      brandStartDate: 'Brand handling date',
      cartDetail: 'Cart item details',
    },
    list: {
      backorder: 'Backorder',
      selectAll: 'Select all',
      latest: 'Latest',
      sort: {
        title: 'Sort',
        brandNameAsc: 'Brand name ascending',
        brandNameDesc: 'Brand name descending',
        itemNameAsc: 'Item name ascending',
        itemNameDesc: 'Item name descending',
        salonPriceAsc: 'Salon price low to high',
        salonPriceDesc: 'Salon price high to low',
        salesStartDateAsc: 'Sales start date oldest first',
        salesStartDateDesc: 'Sales start date newest first',
      },
    },
    selector: {
      selected: 'Selected',
      selectItems: 'Select {{count}} items',
    },
    validation: {
      required: 'Required field',
      min: 'Below {{min}}',
      max: 'Exceeds {{max}}',
      maxLength: 'Exceeds {{max}} characters',
      invalidRange: 'Lower limit must be smaller than upper limit',
      categoryMaxExceeded: 'Category selection exceeds maximum',
      brandMaxExceeded: 'Brand selection exceeds maximum',
      memoMaxBytesExceeded:
        'Must be 14 bytes or less (up to 7 full-width or 14 half-width characters)',
    },
    detailedSearch: {
      title: 'Detailed search',
      categorySelect: 'Category selection',
      brandSelect: 'Brand selection',
      unselected: 'Unselected',
      keywords: 'Keywords',
      salonPrice: 'Salon price',
      retailPrice: 'Manufacturer suggested retail price',
      salesStart: 'Sales start date',
    },
    orderDetail: {
      title: 'Cart item details',
      salesType: 'Sales type',
      quantity: 'Quantity',
      memo: 'Memo',
      price: 'Purchase price',
      subtotal: 'Subtotal',
      close: 'Close',
      edit: 'Edit',
    },
    notSpecified: 'Not specified',
    deleteItem: 'Delete item',
    deleteConfirmation: 'Delete {itemName}?',
    cannotUndo: 'This action cannot be undone.',
    delete: 'Delete',
    close: 'Close',
    confirmDelete: 'Delete',
    edit: 'Edit',
    quantity: 'Quantity',
    quantityLabel: 'Quantity: {count}pcs',
    salonPrice: 'Salon price',
    salonPriceLabel: 'Salon price: {count}yen',
    subtotal: 'Subtotal',
    subtotalLabel: 'Subtotal: {count}yen',
    purchasePrice: 'Purchase price',
    purchasePriceSubtotal: 'Purchase price total',
    purchasePriceSubtotalLabel: 'Purchase price total: {count}yen',
    unavailableForPurchase: 'Temporarily unavailable (please contact sales)',
    unavailableForRegistration:
      'Temporarily unavailable (please contact sales)',
    cancelAllOrder: 'Cancel all orders',
    cancelButton: 'Cancel',
    approvalStatus: 'Approval status',
    separator: ' / ',
    units: 'pcs',
    currency: 'yen',
  },
  category: {
    title: 'Category',
    all: 'All',
    products: 'Products',
    count: 'items',
  },
  colorChart: {
    title: 'Color Chart',
    selectAll: 'Select All',
    color: 'Color',
    allColors: 'View all colors',
    completeItemSelection: 'Complete item selection',
    selectMultipleItems: 'Select multiple items',
  },
  contact: {
    form: {
      title: 'Contact Form',
      userId: 'User ID',
      storeName: 'Store Name',
      email: 'Email Address',
      tel: 'Phone Number',
      business: 'Inquiry Type',
      contents: 'Message',
      submit: 'Submit',
      placeholder: {
        input: 'Please enter',
        tel: 'Please enter without hyphens',
        select: 'Please select',
      },
      business_options: {
        password: 'Forgotten Password',
        locked_account: 'Account Unlock',
        app: 'Website Features',
        other: 'Other Issues',
      },
      note: '※For inquiries about orders, products, or invoices, please contact your sales representative.\n※Depending on the inquiry, it may take some time to respond. Thank you for your understanding.',
      validation: {
        required: 'This field is required',
        maxLength: 'Maximum {max} characters allowed',
        invalidEmail: 'Invalid email address',
      },
    },
    title: 'Contact Us',
    helpText: 'If your problem is not resolved, please contact us',
    submit: 'Contact Us',
    orderInquiries:
      'For inquiries about orders, products, or invoices, please contact your sales representative or branch office.',
    branchHint:
      'Note: If you do not know the branch name, please check the top right of your delivery note or invoice.',
    branchListPrefix: 'Note: For a list of branch phone numbers, click ',
    branchListLink: 'here',
    otherInquiries: 'For other inquiries, please contact us from here',
    links: {
      forgotPassword: 'Forgot Password',
      unlockAccount: 'Unlock Account',
      appFeatures: 'About Site Features',
      otherIssues: 'Other Issues',
    },
    menu: {
      guide: 'Guide',
      faq: 'FAQ',
      help: 'Help',
      contact: 'Contact',
      privacyPolicy: 'Privacy Policy',
      termsOfService: 'Terms of Service',
      law: 'Law',
    },
    complete: {
      title: '{{title}} Completed',
      emailSetting:
        'Please configure your email settings to receive emails from "{{email}}".',
      responseTime:
        'Note: Depending on the content of your {{title}}, it may take some time to respond. Thank you for your understanding.',
      businessHours: '■ Business Hours: Monday to Friday 9:00 - 18:00',
      holidays:
        '■ Closed: Weekends and holidays (Inquiries outside business hours will be responded to on the next business day)',
      returnToTop: 'Return to Top',
    },
    placeholder: {
      email: 'support@altair.mobi',
    },
  },
  favorite: {
    list: {
      title: 'Favorite Lists',
      create: 'Create new list',
      edit: 'List settings',
      name: 'List name',
      shared: 'Share with other salons',
      share: 'Share',
      not_share: 'Do not share',
      delete: 'Delete',
      duplicate: 'Duplicate',
      title_edit: 'Edit title',
      title_edit_share: 'Edit title & sharing settings',
      sales_type: {
        title: 'Default sales type',
        add: 'Add sales type',
        max: 'Maximum {{max}} items allowed',
        description:
          'You can set the default display type for favorite list ({{name}}).',
        setting: 'Set default sales type for this list',
        close: 'Close',
        save: 'Save',
      },
      validation: {
        required: 'This field is required',
        max_length: 'Maximum {{max}} characters allowed',
      },
      sharing: {
        title: 'Share with stores',
        share: 'Share',
        not_share: 'Do not share',
      },
      action: {
        message: {
          create: 'Favorite list has been created',
          update: 'Favorite list has been updated',
          updateSetting: 'Favorite list settings have been updated',
          sort: 'Favorite list order has been updated',
          delete: 'Favorite list has been deleted',
          copy: 'Selected favorite items have been copied',
        },
      },
    },
    item: {
      title: 'Favorite Items',
      count: '{{count}} items',
      count_unit: 'items',
      empty: 'No items',
      add: 'Add',
      remove: 'Remove',
      remove_description: {
        line1: 'Remove selected items',
        line2: 'from favorite list "{{name}}".',
      },
      move: 'Move',
      copy: 'Copy',
      edit: 'Edit',
      selected_count: '{{count}} items selected',
      sort: 'Sort',
      sort_title: 'Sort',
      settings: 'Type settings',
      bulkUpdate: 'Bulk update sales type & quantity',
      bulkUpdateDescription:
        'Bulk update sales type and quantity for currently selected items.',
      moveFolder: 'Move folder',
      moveDescription: 'Select a folder to move or copy the selected items to.',
      myListEmpty: 'No lists available',
      listEmpty: 'No lists available',
      editList: 'Edit list',
      selectAll: 'Select all',
      janCode: 'JAN Code',
      productCode: 'Product Code',
      action: {
        message: {
          sort: 'Favorite item order has been updated',
          copy: 'Selected favorite items have been copied',
          move: 'Selected favorite items have been moved',
          delete: 'Selected favorite items have been deleted',
          addCart: 'Selected favorite items have been added to cart',
        },
      },
    },
    modal: {
      add: 'Add to favorites',
      cancel: 'Cancel',
      confirm: 'Confirm',
      close: 'Close',
      save: 'Save',
      save_item: 'Save',
      delete: 'Delete',
      copy: 'Copy',
      move: 'Move',
      delete_title: 'Delete',
      delete_description: 'This action cannot be undone.',
    },
    notification: {
      create: 'Favorite list created',
      update: 'Favorite list updated',
      delete: 'Favorite list deleted',
      item_add: 'Item added to favorites',
      item_remove: 'Item removed from favorites',
      item_move: 'Favorite item moved',
      item_copy: 'Favorite item copied',
    },
    error: {
      fetchDetailFailed: 'Failed to fetch favorite details',
    },
    bulkUpdate: {
      mode: {
        both: 'Both',
        salesType: 'Sales Type',
        quantity: 'Quantity',
      },
      validation: {
        required: 'This field is required',
        min: 'Below {min}',
        max: 'Exceeds {max}',
      },
    },
    title: 'Favorites',
    titleAlias: 'Favorite List',
  },
  guide: {
    relatedItems: 'Related Items',
    title: 'Guide',
  },
  help: {
    title: 'Help',
    error: {
      fetchFailed: 'Failed to fetch content',
      tryAgainLater: 'Please try again later',
    },
    close: 'Close',
    button: {
      addOtherItemToConfirmedOrder: 'How to add items not listed below?',
    },
  },
  invoice: {
    title: 'Invoice',
    list: {
      title: 'Invoice List',
      empty: 'No invoices available',
      download: 'Download',
      preview: 'Preview',
      bulk: {
        downloadZip: 'Download as ZIP',
        latest: 'Latest',
      },
      history: 'History',
      status: {
        all: 'All',
        paid: 'Paid',
        unpaid: 'Unpaid',
        overdue: 'Overdue',
      },
    },
    filter: {
      title: 'Filter',
      apply: 'Apply',
      reset: 'Reset',
      close: 'Close',
      dateRange: 'Date Range',
      status: 'Status',
      store: 'Store',
      search: 'Search',
      placeholder: {
        partialMatch: 'Partial match',
      },
      sort: {
        invoiceNameAsc: 'Invoice Name (Ascending)',
        invoiceNameDesc: 'Invoice Name (Descending)',
        invoiceCodeAsc: 'Invoice Code (Ascending)',
        invoiceCodeDesc: 'Invoice Code (Descending)',
        invoicePriceAsc: 'Invoice Amount (Ascending)',
        invoicePriceDesc: 'Invoice Amount (Descending)',
        invoicePublishAsc: 'Last Issue Date (Ascending)',
        invoicePublishDesc: 'Last Issue Date (Descending)',
        invoiceClosingAsc: 'Billing Closing Date (Ascending)',
        invoiceClosingDesc: 'Billing Closing Date (Descending)',
      },
    },
    search: {
      title: 'Invoice Search',
      placeholder: 'Search invoices',
      byMonth: 'Filter by billing month',
      byClosingDate: 'Filter by billing closing date',
      invalidRange: 'End month must be on or after the start month',
      byStore: 'Search by Store',
      multiStore: 'Multi-Store Search',
      download: 'Download',
      selectMonth: 'Select month',
      selectStore: 'Select Store',
      status: {
        all: 'Show All',
        notDownloaded: 'Not Downloaded Invoices',
        downloadedAndMailed: 'Downloaded/Mailed Invoices',
      },
      year: 'Year',
      month: 'Month',
    },
    preview: {
      title: 'Invoice Preview',
      close: 'Close',
      download: 'Download',
      notFound: ' not found',
      systemError: 'A system error occurred',
    },
    history: {
      title: 'Invoice History',
      close: 'Close',
      date: 'Date',
      action: 'Action',
      user: 'User',
      noHistory: 'No history available',
      downloadCsv: 'Download history CSV',
      operation: {
        cancelMailed: 'Cancel mailed',
        delete: 'Delete',
        download: 'Download',
        drafted: 'Drafted',
        mailed: 'Mailed',
        opDownloaded: 'Download (Operations)',
        published: 'Published',
        rejected: 'Rejected',
        unpublished: 'Unpublished',
      },
    },
    download: {
      title: 'Download',
      progress: 'Downloading',
      complete: 'Download Complete',
      failed: 'Download Failed',
      retry: 'Retry',
      receipt: 'Receipt',
      receiptDownload: 'Receipt Download',
    },
    detail: {
      invoiceNumber: 'Invoice Number',
      billingClosingDate: 'Billing Closing Date',
      issueDate: 'Issue Date',
      dueDate: 'Due Date',
      totalAmount: 'Total Amount',
      status: 'Status',
      items: 'Items',
      subtotal: 'Subtotal',
      tax: 'Tax',
      total: 'Total',
    },
    file: {
      preview: 'Preview',
      download: 'Download',
      bulk: 'Bulk Download',
      history: 'History',
      status: {
        downloaded: 'Downloaded',
        notDownloaded: 'Not downloaded',
        mailed: 'Mailed',
        invalid: 'Invalid version',
        noInvoice: 'No invoice',
      },
    },
    notFound: {
      common: 'No invoices found matching the search criteria.',
      filter: 'No invoices found matching the filter criteria.',
      history: 'No history found matching the search criteria.',
      preview: 'No preview found matching the search criteria.',
    },
  },
  purchase: {
    common: {
      filter: 'Filter',
    },
    csv: {
      download: 'CSV Download',
      downloading: 'Downloading file',
      downloadingMessage: 'Please wait until download completes',
      cancel: 'Cancel',
    },
    searchForm: {
      importDate: 'Import Date',
      shippingDate: 'Shipping Date',
      systemType: 'Type',
      ecSalesOrderNo: 'EC Order No.',
      placeholder: {
        importDate: 'Please select',
        shippingDate: 'Please select',
        systemType: 'Please select',
        ecSalesOrderNo: 'Please enter',
      },
    },
    table: {
      ecOrderNo: 'EC Order No.',
      importDateTime: 'Import Date/Time',
      shippingDate: 'Shipping Date',
      trackingNo: 'Tracking No.',
      systemType: 'Type (Delivery ID)',
      deliveryAddress: 'Delivery Prefecture',
      deliveryName: 'Delivery Name',
      deliveryCompanyName: 'Delivery Company Name',
    },
    orderItems: {
      rowNo: 'Row No.',
      janCode: 'JAN',
      itemName: 'Item Name',
      quantity: 'Quantity',
    },
    kvList: {
      importDateTime: 'Import Date/Time',
      shippingDate: 'Shipping Date',
      trackingNos: 'Tracking No.',
      systemType: 'Type',
      ecSalesOrderNo: 'EC Order No.',
      fileName: 'File Name',
      deliveryId: 'Delivery ID',
      deliveryName: 'Delivery Name',
      deliveryAddress: 'Delivery Address',
      desiredDeliveryDate: 'Desired Delivery Date',
      desiredDeliveryTime: 'Desired Delivery Time',
      scheduledShippingDate: 'Scheduled Shipping Date',
      scheduledArrivalDate: 'Scheduled Arrival Date',
      shippingWarehouse: 'Shipping Warehouse',
      shippingCompany: 'Shipping Company',
      salesOrderNo: 'Sales Order No.',
      salesNos: 'Sales Order No.',
    },
    fields: {
      ecSalesOrderNo: 'EC Order No.',
      importDateTime: 'Import Date/Time',
      shippingDate: 'Shipping Date',
      trackingNos: 'Tracking No.',
      systemType: 'Type',
      deliveryAddress: 'Delivery Address',
      deliveryName: 'Delivery Name',
      desiredDeliveryDate: 'Desired Delivery Date',
      desiredDeliveryTime: 'Desired Delivery Time',
      scheduledShippingDate: 'Scheduled Shipping Date',
      scheduledArrivalDate: 'Scheduled Arrival Date',
      shippingWarehouse: 'Shipping Warehouse',
      shippingCompany: 'Shipping Company',
      salesOrderNo: 'Sales Order No.',
      salesNos: 'Sales Order No.',
      fileName: 'File Name',
      deliveryId: 'Delivery ID',
      startFrom: 'Start from',
    },
    shipmentStatus: {
      unshipped: 'Unshipped',
      shipped: 'Shipped',
    },
  },
  purchasedInfo: {
    common: {
      search: 'Search',
      clearSearch: 'Clear Search',
      noData: 'No items match the criteria.',
      noDataMessage: 'Please change the conditions and search again.',
      downloading: 'Downloading file',
      downloadingMessage: 'Please wait until the download completes',
      cancel: 'Cancel',
      csvDownload: 'CSV Download',
      total: 'Total',
      unit: 'items',
      failedToDownload: 'Failed to download',
    },
    form: {
      selectPlaceholder: 'Please select',
      orderDate: 'Order Date',
      shippingDate: 'Shipping Date',
      storeCode: 'Store',
      unit: 'Aggregation Unit',
      statTarget: 'Aggregation Target',
      billMonth: 'Billing Month',
      itemCode: 'Item Code',
      allStores: 'All Stores',
      notSpecified: 'Not Specified',
      startDate: 'Start Date',
      endDate: 'End Date',
    },
    unit: {
      store: 'Customer',
      billStore: 'Billing Store',
      depositStore: 'Deposit Store',
    },
    statTarget: {
      orderStat: 'Order',
      billingStat: 'Billing',
    },
    subTitle: {
      salesDetail: 'Details',
      billedAmounts: 'Billed Amounts',
      makers: 'By Maker',
      makersStores: 'By Maker and Store',
      stores: 'By Store',
      storesSalesTypes: 'By Store and Sales Type',
      storesMakersSalesTypes: 'By Store, Maker and Sales Type',
    },
    dataList: {
      backButton: 'Back',
    },
    details: {
      salesDetail:
        "Order Date / Shipping Date / Sales Number / Sales Line Number / Store Code / Store Name / Sales Type / Manufacturer / Product Code / Product Name / JAN Code / Category / Order Quantity / Shipping Quantity / Unit Price / Amount / Remarks / Salon Price / Manufacturer's Suggested Retail Price / Import Number",
      billedAmounts:
        'Billing Date / Payment Date / Invoice No. / Billing Code / Billing Name / Carry-over Amount / Monthly Sales Total / Document Adjustment / Consumption Tax / Current Invoice Amount',
      makers:
        'Manufacturer / Manufacturer Code / Order Quantity / Shipping Quantity / Salon Price',
      makersStores: 'Store ID / Store Name / Manufacturer Name / Shipping Fee',
      stores:
        'Store ID / Store Name / Order Quantity / Shipping Quantity / Salon Price',
      storesSalesTypes: 'Store ID / Store Name / Sales Type',
      storesMakersSalesTypes:
        'Store ID / Store Name / Manufacturer Code・Sales Type',
    },
    subPage: {
      title: {
        salesDetail: 'Details',
        billedAmounts: 'Billed Amounts',
        makers: 'Makers',
        makersStores: 'Makers Stores',
        stores: 'Stores',
        storesSalesTypes: 'Stores Sales Types',
        storesMakersSalesTypes: 'Stores Makers Sales Types',
      },
    },
  },
  orderHistory: {
    statusBar: {
      desiredDeliveryDateError: 'Orders requiring delivery date change',
      unapprovedOrder: 'Unapproved orders exist',
    },
    paymentTable: {
      salonPrice: 'Salon Price',
      purchasePrice: 'Purchase Price',
      totalAmount: 'Total Amount',
      untilFreeShipping: 'Until Free Shipping',
      subtotal: 'Subtotal',
    },
    footer: {
      totalPriceDisplay: 'Total Price Display',
      approvalCancel: 'Cancel Approval',
      approve: 'Approve',
    },
    list: {
      backOrderItems: 'Back Order Items',
      backOrderNote: '※Please allow some time for delivery',
      orderNumber: 'Order Number',
      error: 'Error',
      cancel: 'Cancel',
      cancelConfirmation: 'Cancel Order',
      cancelMessage: 'Cancel order ({orderNo}).',
      cancelWarning: 'This operation cannot be undone.',
      close: 'Close',
      cancelOrder: 'Cancel',
      bulkCancelUnshipped: 'Cancel Unshipped Orders',
    },
    detail: {
      orderNumber: 'Order Number: ',
      deliveryInfo: 'Delivery Information',
      trackingNumber: 'Tracking Number',
      desiredDeliveryDate: 'Desired Delivery Date',
      deliveryAddress: 'Delivery Address',
      purchasedItems: 'Purchased Items',
      byItem: 'By Item',
      shippingCompanyName: 'Shipping Company',
      byOrderNumber: 'By Order',
      register: 'Register',
      repurchase: 'Repurchase',
      back: 'Back',
      none: 'Not Set',
    },
    item: {
      notSpecified: 'Not Specified',
      deleteItem: 'Delete Item',
      deleteConfirmation: 'Delete {itemName}.',
      cannotUndo: 'This operation cannot be undone.',
      delete: 'Delete',
      close: 'Close',
      confirmDelete: 'Delete',
      detail: 'Detail',
      edit: 'Edit',
      quantity: 'Quantity',
      quantityLabel: 'Quantity: {count} items',
      salonPrice: 'Salon Price',
      salonPriceLabel: 'Salon Price: ¥{price}',
      subtotal: 'Subtotal',
      subtotalLabel: 'Subtotal: ¥{amount}',
      purchasePrice: 'Purchase Price',
      purchasePriceSubtotal: 'Purchase Price Subtotal',
      purchasePriceSubtotalLabel: 'Purchase Price Subtotal: ¥{amount}',
      averagePurchasePrice: 'Average Purchase Price',
      unavailableForPurchase: 'Unavailable for purchase (contact sales)',
      unavailableForRegistration:
        'Unavailable for registration (contact sales)',
      cancelAllOrder: 'Cancel Order',
      cancelButton: 'Cancel',
      approvalStatus: 'Status',
    },
    filter: {
      validation: {
        storeSelection: 'Please select at least one store',
        dateRange: 'End date must be after start date',
      },
    },
  },
  orderImport: {
    csvUploader: {
      noFileSelected: 'No file selected',
      register: 'Register',
      fileTooLarge:
        'The file exceeds the upload size limit. Please upload a CSV file up to 3.5MB.',
    },
    timeout: {
      notification: 'Notification',
      message:
        'Processing is taking longer than expected.\nPlease check the order import later.',
      close: 'Close',
    },
    main: {
      title: 'Order Import (Total: {{total}})',
    },
    result: {
      showAll: 'Show All',
      showSuccessOnly: 'Show Success Only',
      showErrorOnly: 'Show Error Only',
    },
    searchForm: {
      systemType: 'Import Type',
      orderDateFromTo: 'Import Date',
      startDate: 'Start Date',
      endDate: 'End Date',
      dateRangeError: 'End date must be after start date',
    },
  },
  passwordReset: {
    title: 'Please change your password',
    form: {
      password: 'Password',
      passwordConfirm: 'Password (Confirm)',
      passwordHint: 'Please enter a password between 6 and 20 characters.',
      save: 'Save',
      requiredField: 'This field is required',
      minLength: 'Minimum length is {length} characters',
      maxLength: 'Maximum length is {length} characters',
      passwordMismatch: 'Passwords do not match',
      noPermission: 'You do not have permission to change the password.',
    },
  },
  employeeHeader: {
    agencyStatusSuffix: ' is selected for proxy login',
    agencyNotSelected: 'No customer is selected for proxy operation',
    changeAgency: 'Change',
    agencySelectionTitle: 'Select customer for proxy operation',
    agencySelectionDescription: 'Please select a customer for proxy operation.',
    customerCodeLabel: 'Customer code',
    depositParentCodeLabel: 'Deposit parent code',
    close: 'Close',
    confirm: 'Confirm',
    or: 'Or',
    stopAgency: 'Stop proxy operation',
  },
  selectStore: {
    title: 'Select a customer to proxy',
    description:
      'To perform proxy ordering and related actions, please select the target customer.',
    customerCodeLabel: 'Customer code',
    storeNameLabel: 'Store name',
    depositParentCodeLabel: 'Deposit parent code:',
    loginWithStore: 'Log in with this store',
    searchButton: 'Search',
    or: 'Or',
    loginWithoutSelection: 'Log in without selecting a customer',
    noResults: 'No matching results',
  },
  privacyPolicy: {
    title: 'Privacy Policy',
  },
  termsOfService: {
    title: 'Terms of Service',
  },
  tokushoho: {
    title: 'Specified Commercial Transaction Act',
  },
  search: {
    title: 'Search',
    freeWord: 'Search by keyword',
    detailedSearch: 'Advanced Search',
    barcodeSearch: 'Barcode Search',
    byCondition: 'Search by Criteria',
    byCategory: 'Browse by Category',
    byBrand: 'Browse by Brand',
  },
  barcode: {
    readerScan: 'Scan with Barcode Reader',
    readerConnectionGuide:
      'Connect the barcode reader and\nscan the product barcode',
    scanItem: 'Products will be displayed when barcode is scanned',
    searching: 'Searching for product...',
    itemAdded: 'Product added',
    itemFound: 'Product found',
    itemNotFound: 'Product not found',
    addToCart: 'Add to Cart',
    totalItems: 'Total items',
    subtotal: 'Subtotal',
  },
  lineup: {
    title: 'Lineup',
  },
  receipt: {
    title: 'Receipt',
    list: {
      title: 'Receipt List',
      empty: 'No receipts found',
      download: 'Download',
      preview: 'Preview',
      history: 'History',
      status: {
        all: 'All',
        paid: 'Paid',
      },
    },
  },
}

export default dict
